import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { fetchData } from "../../Components/common/utils";

const Blogs = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageLoaded, setImageLoaded] = useState({});
  const [searchTerm, setSearchTerm] = useState(""); // 🔍 search state

  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/blog";
      const result = await fetchData(url);
      if (result.status) {
        setData(result.data);
        setLoading(false);
      }
    };
    fetchApiData();
  }, []);

  const handleImageLoad = (id) => {
    setImageLoaded((prev) => ({ ...prev, [id]: true }));
  };

  const skeleton = () => (
    <div className="d-flex gap-3">
      <div className="skeleton skeleton-img flex-shrink-0"></div>
      <div className="w-100">
        <div className="skeleton skeleton-title"></div>
        <div className="skeleton skeleton-text"></div>
        <div className="skeleton skeleton-text"></div>
        <div className="skeleton skeleton-text"></div>
      </div>
    </div>
  );

  // ✅ Filter blogs by title
  const filteredBlogs = data.length > 0 ? data?.filter((blog) =>
    blog.title.toLowerCase().includes(searchTerm.toLowerCase())
  ) :[]; 

  return (
    <>
      <section className="blog-section py-5">
        <div className="container">
          <h1 className="text-center mb-3">Our Blog</h1>

          {/* 🔍 Search Box */}
          <div className="d-flex justify-content-center mb-4">
            <input
              type="text"
              className="form-control blog-search"
              placeholder="Search blogs by title..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className={`our-blog-wrapper ${loading ? "gap-3" : ""}`}>
            {filteredBlogs.length > 0 ? (
              filteredBlogs.map((details) => (
                <div className="blog-card" key={details.id}>
                  <div className="img-wrapper overflow-hidden position-relative">
                    {!imageLoaded[details.id] && (
                      <div className="skeleton skeleton-img me-3"></div>
                    )}
                    <Link to={`/blogs/${details.slug}`}>
                      <img
                        src={details.media[0]?.original_url}
                        alt={details.title}
                        style={{
                          display: imageLoaded[details.id] ? "block" : "none",
                        }}
                        onLoad={() => handleImageLoad(details.id)}
                      />
                    </Link>
                  </div>
                  <div>
                    <Link
                      to={`/blogs/${details.slug}`}
                      className="blog-title link"
                    >
                      {details.title}
                    </Link>
                    <div className="blog-date">
                      {moment(details.created_at).format("MMMM DD, YYYY")}
                    </div>
                    <p className="blog-description truncate-text">
                      {details.short_description}
                    </p>
                    <Link className="link" to={`/blogs/${details.slug}`}>
                      Read More
                    </Link>
                  </div>
                </div>
              ))
            ) : (
              !loading && (
                <p className="text-center text-muted">No blogs found.</p>
              )
            )}

            {loading && (
              <>
                {skeleton()}
                {skeleton()}
                {skeleton()}
                {skeleton()}
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blogs;
